import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { FluidContainer, Column, Row } from '@comparethemarketau/manor-grid';
import { Typography } from '@comparethemarketau/manor-typography';

import { ProviderLogo } from '../../products/common/provider_logo';

const ProviderLogoGrid = ({ logoClassName, titleClassName, className }) => {
    return (
        <div className={classNames('test-emptyState-providerLogoGrid', className)}>
            <Typography className={titleClassName}>
                {'Providers we asked to return a quote'}
            </Typography>
            <FluidContainer>
                <Row justify={'center'}>
                    {
                        logos.map((code) => (
                            <Column xs={4} sm={3} md={2} lg={2} valign="center" key={`provider-logo-${code}`}>
                                <ProviderLogo className={logoClassName} code={code} />
                            </Column>
                        ))
                    }
                </Row>
            </FluidContainer>
        </div>
    );
};

ProviderLogoGrid.propTypes = {
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    logoClassName: PropTypes.string
};

export { ProviderLogoGrid };

const logos = [
    'CARP', 'BUDD', 'VIRG', 'STEL', 'WOOL', '1FOW', 'OZIC', 'RETI', 'HUDD', 'EXOA', 'EXIG'
];
